'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenGraph = function OpenGraph(_ref) {
    var title = _ref.title;
    var type = _ref.type;
    var url = _ref.url;
    var description = _ref.description;
    var image = _ref.image;
    return _react2.default.createElement(_reactHelmet2.default, {
        meta: [{ property: 'og:url', content: url }, { property: 'og:type', content: type }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: image }]
    });
};

OpenGraph.propTypes = {
    title: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired,
    image: _propTypes2.default.string.isRequired
};

exports.default = OpenGraph;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-open-graph/lib/cjs/index.js
 ** module id = 667
 ** module chunks = 1
 **/